module.exports = __webpack_public_path__ + "static/media/moped.8bec5fb7.jpg";